import { memo as Memo, useMemo, useState, useRef, useEffect, useCallback } from 'react'

import { gsap, TweenLite } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)
gsap.core.globals('ScrollTrigger', ScrollTrigger)

import { arrayGenChild } from 'helpers'

//* HOC's
import { withDataContext, withLanguageContext, withUIContext } from 'context'

//* Components
import { Image, Page, Text, Icon, Container, AnimationWrapp } from 'components/common'

//* Styles
import ContactStyle from 'styles/pages/ContactStyle'

const ContactUs = Memo(({ pages, pageParams, selectedLang, preloader, ...props }) => {
    //! Page Data
    const pageData = useMemo(() => pages?.[pageParams.name]?.[selectedLang], [pages, selectedLang, pageParams.name])

    //! State
    const [secObj, setSecObj] = useState()
    const [otherItem, setOtherItem] = useState()

    //! ref
    const titleRef = useRef()
    const descriptionRef = useRef()
    const Ref2 = useRef()
    const Ref3 = useRef()
    const Ref4 = useRef()

    const mouseOver = useCallback(
        (e) => {
            if (props.winWidth >= 1024 && e.clientX) {
                let diffX = e.clientX - props.winWidth / 2
                let diffY = e.clientY - props.winHeight / 2

                TweenLite.to(Ref2.current.firstChild.firstChild, {
                    x: diffX / -15,
                    y: diffY / -15,
                })
            }
        },
        [props.winWidth, props.winHeight]
    )

    const mouseOut = useCallback(() => {
        if (props.winWidth >= 1024) {
            TweenLite.to(Ref2.current.firstChild.firstChild, 0.5, {
                y: 0,
                x: 0,
            })
        }
    }, [])

    const config = [
        {
            scale: 1,
            ease: 'power1.out',
            duration: 0.9,
        },
        {
            x: 0,
            stagger: 0.05,
            delay: 0.4,
            ease: 'power1.out',
            duration: 0.8,
        },
    ]

    useEffect(() => {
        if (pageData && titleRef?.current && descriptionRef?.current && !preloader) {
            setOtherItem([
                [Ref2.current, Ref2.current.firstChild],
                [Ref3.current.childNodes, Ref4.current],
            ])

            setSecObj([arrayGenChild(titleRef.current.childNodes[0].childNodes), descriptionRef.current])
        }
    }, [titleRef.current, descriptionRef.current, Ref2.current, Ref3.current, Ref4.current, pageData, preloader])

    return (
        <ContactStyle>
            <Page
                className='contact-page'
                meta={{
                    title: pageData?.content?.meta?.title,
                    description: pageData?.content?.meta.description,
                    keywords: pageData?.content?.meta.keywords,
                    image: pageData?.content.meta_image,
                }}
            >
                {pageData && (
                    <AnimationWrapp state={secObj} otherItem={otherItem} afterComplete={config}>
                        <Container className='contact-page-block last'>
                            <div className='top-section'>
                                <Text tag={'stringToLetters'} className={'h1 title MonBold black'} text={pageData?.content.title} ref={titleRef} />
                                <Text tag={'h6'} className={'description h6 MonRegular black'} text={pageData?.content.text} ref={descriptionRef} />
                            </div>
                            <div className='main-section overflowHidden'>
                                <div className='img' ref={Ref2} onMouseMove={(e) => mouseOver(e)} onMouseLeave={(e) => mouseOut(e)}>
                                    <Image src={pageData?.content.image} alt={pageData?.content.title} />
                                </div>
                                <div className='info'>
                                    <div className='content' ref={Ref3}>
                                        <div className='single-info'>
                                            <Text tag={'h5'} className={'title uppercase h5 MonRegular black'} text={'contactUsText'} />
                                            <Text tag={'h3'} className={'h3 MonMedium black'} text={pageData?.content.email} />
                                        </div>
                                        <div className='single-info'>
                                            <Text tag={'h5'} className={'title uppercase h5 MonRegular black'} text={'addressText'} />
                                            <Text tag={'h3'} className={'h3 MonMedium black'} text={pageData?.content.address} />
                                        </div>
                                    </div>
                                    <div className='social' ref={Ref4}>
                                        <a target='_blank' href={pageData?.content.socials.facebook} rel='noopener noreferrer' aria-label="facebook">
                                            <Icon className='icon-facebook' />
                                        </a>
                                        <a target='_blank' href={pageData?.content.socials.linkedin} rel='noopener noreferrer' aria-label="linkedin">
                                            <Icon className='icon-linkedin' />
                                        </a>
                                        <a target='_blank' href={pageData?.content.socials.twitter} rel='noopener noreferrer' aria-label="twitter">
                                            <Icon className='icon-twitter' />
                                        </a>
                                        <a target='_blank' href={pageData?.content.socials.telegram} rel='noopener noreferrer' aria-label="telegram">
                                            <Icon className='icon-telegram' />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </Container>
                    </AnimationWrapp>
                )}
            </Page>
        </ContactStyle>
    )
})

export default withLanguageContext(withUIContext(withDataContext(ContactUs, ['pages']), ['screenSizes', 'winWidth', 'winHeight']), ['selectedLang'])
